import { PropertyTab } from 'components/pages/Property/ClientProperty/_main/contexts'
import { ProductKindsWithDocumentGallery } from 'constants/product'
import { RealEstatePropertyAssignmentDTO } from 'models/property'

export const getPropertyAssignmentsTab = (data: RealEstatePropertyAssignmentDTO | undefined) => {
  if (!data) return undefined

  const isAssignmentsWithDocumentProduct = data.products.some(product => ProductKindsWithDocumentGallery.has(product.kind))

  if (isAssignmentsWithDocumentProduct) {
    return PropertyTab.DOCUMENTS
  }

  return PropertyTab.GALLERY
}
